import { Employee } from '../../reservation/models/reservation.model';
import { Table } from '../../tables/models/table-list.model';
import { CalledStatus } from '../enums/called-status.enum';
import { CalledEvent } from './called-event.model';

export class Called {
  id: number;
  table: Table;
  description: string;
  status: CalledStatus;
  events: CalledEvent[];
  count: number;
  employee: Employee;

  //aux view
  createdAt: string;
  attendedAt: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    this.createdAt = this.dateOfEvent(CalledStatus.IN_QUEUE);
    this.attendedAt = this.dateOfEvent(CalledStatus.CONFIRMED);
  }

  dateOfEvent(status: CalledStatus): string {
    const event = (this.events || []).find((ev) => ev.eventStatus == status);
    if (event) {
      return event.createdDate;
    }
    return '-';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/call-attendant/models/called.model.ts